(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-brands"] && !Shopify.designMode) return;
  try {
    
    class Brands extends HTMLElement {
        constructor() {
            super();
            this.currentLetter;
            this.prevLetter;
            
            let letters =  this.querySelectorAll('.brand-initial'); 
            
            letters.forEach((letter)=> {
                letter.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.scrollToBrand(e.target);
                    return false;
                }); 
            });
            this.reorderBrands();
          
        
        }
        scrollToBrand(letter) {
            this.setCurrentLetter(letter);
            let headerHeight = document.querySelector('header').offsetHeight          
            let elem = this.querySelector('#'+letter.innerHTML)
            const y = elem.getBoundingClientRect().top + window.scrollY;
            window.scroll({
                top: y,
                behavior: 'smooth'
            });
        }
        setCurrentLetter(letter) {
            if (this.currentLetter) {
                this.prevLetter = this.currentLetter;
                this.prevLetter.style.fontWeight = 'normal';
                this.prevLetter.style.borderBottom = 'unset';
            }
            this.currentLetter = letter;
            this.currentLetter.style.fontWeight = 'bold';
            this.currentLetter.style.borderBottom = '1px solid black';
        }
        reorderBrands() {
            let mq = window.matchMedia("(min-width: 750px)");
            if (mq.matches) {
                let brands = this.querySelector('.brands');
                let screenWidth = brands.offsetWidth;
                let brands_num = brands.querySelectorAll('div.letter-container').length;
                let brands_in_col;
                //calculate number of brands per col
                brands_in_col =  Math.round(brands_num / 4);
                let brands_counter = 1;
                let col_index = 1;
                brands.querySelectorAll('div.letter-container').forEach(function(brand, index){
                if(brands_counter == brands_in_col){
                    brands.querySelector('.col-' + col_index + '').appendChild(brand);
                    brands_counter = 1;
                    col_index++;
                } else {
                var col;
                if(brands_counter == 1){
                    col = document.createElement('div');
                    col.classList.add('col');
                    col.classList.add('col-' + col_index);
                    col.appendChild(brand);
                    brands.appendChild(col);
                } else {
                    brands.querySelector('.col-' + col_index + '').appendChild(brand);
                }
                brands_counter++;
                }
                })
                brands.style.display = 'flex';
            } 
        }
    }
    customElements.define('brands-collection', Brands);
  
  } catch(e) { console.error(e); }
})();
})();
